import { FETCH_INSTANCES_SEARCH_RESULTS } from "../../../../../graphql/query/Instance";
import { instanceFilterStore } from "../../../components/useInstanceFilters";

const SearchedInstances = props => {
  const tableProps = {
    dataKey: "instancesV2",
    FETCH_QUERY: FETCH_INSTANCES_SEARCH_RESULTS,
    limit: 50,
    variables: {
      ...instanceFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedInstances;
